//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Returns initials for a given name, splitting on spaces and underscores, up to 3 initials.
 * If name is empty/undefined, uses the default string.
 * @param name The name string to extract initials from.
 * @param defaultStr The fallback string if name is empty/undefined.
 * @returns {string} Initials (max 3 chars)
 */
export function getInitials(
  name: string | undefined,
  defaultStr: string,
): string {
  const base = name && name.trim() ? name : defaultStr;
  const words = base.split(/[ _]+/);
  let initials = '';
  for (const word of words) {
    if (initials.length < 3 && word.length > 0) {
      initials += word.charAt(0).toUpperCase();
    }
  }
  return initials;
}
